/**
 * @description
 * returns true if zone.js polyfills are imported, false otherwise
 */
export function isZonePresent(): boolean {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // return !!(window as any).Zone;
    return true;
}
